module.exports = __webpack_public_path__ + "img/file-ppt.2339e5dc.svg";